<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EkIFxe/images/cover.jpg?1684306200713" alt="This image is the cover for the book Razing of Tinton Falls: Voices from the American Revolution"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Razing of Tinton Falls: Voices from the American Revolution
      </h1>
      <p class="bookDescription body article font2">
        <p>On June 10, 1779, a Loyalist raiding party landed on the shore of Monmouth County, New Jersey, and advanced unnoticed on the town of Tinton Falls. It captured five leading Patriots and plundered many others. Homes and barns were burned to the ground; stores were looted and livestock driven off. The local militia scattered. That afternoon, as the raiders loaded their barges, a reinforced militia engaged the Loyalists in a battle that climaxed with vicious hand-to-hand combat. Historian Michael Adelberg brings the Tinton Falls raid to life, re-creating the day in the voices of ten narrators based on real people--a child of a Revolutionary leader, a Loyalist officer, a militiaman, a pacifist, a businesswoman and many others--each of whom experienced the day very differently.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael S. Adelberg
      </h2>
      
      <p class="authorDescription body article">Michael Adelberg has been researching the American Revolution in Monmouth County for more than twenty years and is the author of the award-winning The American Revolution in Monmouth County: The Theatre of Spoil and Destruction. His essays on the American Revolution have appeared in scholarly journals like the Journal of Military History and the Journal of the Early Republic. He is a fiction reviewer for the New York Journal of Books, and his first novel, A Thinking Man's Bully, was published in January 2012. Adelberg holds master's degrees in history and public policy and lives with his family in Vienna, Virginia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?28fa1916